import React from 'react';
import { useTranslation } from 'react-i18next';

interface PinButtonProps {
  isPinned: boolean;
  onToggle: () => void;
}

const PinButton: React.FC<PinButtonProps> = ({ isPinned, onToggle }) => {
  const { t } = useTranslation();

  return (
    <button
      className={`pin-button ${isPinned ? 'pinned' : ''}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
      title={isPinned ? t('sidebar.unpin') : t('sidebar.pin')}
      type="button"
    >
      <i className="fas fa-thumbtack" />
    </button>
  );
};

export default PinButton;
